import DonutFillChart from './DonutFillChart'

export default DonutFillChart
